import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';

import WrapperStatsQuery from '../../../../../../Stats/Charts/WrapperStatsQuery';
import Kpis from './Kpis';

function Stats({ post, showTitle = false }: any) {
  return (
    <Box
      sx={{
        px: { xs: 0, sm: 2 },
        pb: 3,
      }}
    >
      {showTitle && (
        <Typography
          variant="body1"
          component="h3"
          sx={{
            fontWeight: 'bold',
            mt: 5,
            mb: 3,
          }}
        >
          <FormattedMessage id="POSTS.STATS.TITLE_PARTICIPATION" />
        </Typography>
      )}

      <Box
        sx={{
          mb: 2,
        }}
      >
        <WrapperStatsQuery statsSlug="kpis_without_progression" postId={post.id}>
          <Kpis postType={post.type} />
        </WrapperStatsQuery>
      </Box>
    </Box>
  );
}

export default Stats;
